// extracted by mini-css-extract-plugin
module.exports = {"portraitDummy":"index_portraitDummy_QvnkR","portraitDummy__text":"index_portraitDummy__text_1Kxlf","text__img":"index_text__img_1n2-D","text__title":"index_text__title_p1H76"};